'use client';

import Link from 'next/link';

import {
  LOCALE_PHONE_NUMBERS_CONFIG,
  MAIL_CONFIG,
  SOCIAL_CONFIG,
} from '../constants';

import EnvelopeFill from '@/assets/icons/iconEnvelopeFill.svg';
import IconMax from '@/assets/icons/iconMax.svg';
import { MaskedPhone } from '@/shared/components/maskedPhone';
import { useGetClientHost } from '@/shared/hooks';
import { TranslatedComponent } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

export const ContactsRuDesktop = ({ translations }: TranslatedComponent) => {
  const clientHost = useGetClientHost();
  const localePhoneNumber =
    LOCALE_PHONE_NUMBERS_CONFIG[getDomainKey(clientHost)]?.href;

  const mail = MAIL_CONFIG[getDomainKey(clientHost)];

  if (!localePhoneNumber) {
    return null;
  }

  return (
    <section
      id="contacts"
      className="bg-surface-base-secondary mt-7 flex flex-wrap items-center gap-y-[6px] rounded-[28px] pr-9 xl:gap-x-[140px]"
    >
      <MaskedPhone
        phoneNumber={localePhoneNumber}
        message={translations.formPhoneConsentMessage}
        loadingMessage={translations.loadingMessage}
      />

      <div className="flex flex-col">
        <Link
          href={translations.contactsOfficeMapLink}
          aria-label={translations.contactsOfficeMapLink}
          className="mb-3 text-[16px] leading-[24px]"
          target="_blank"
        >
          {translations.contactsOfficeMapText}
        </Link>

        <Link
          href={`mailto:${mail}`}
          className="text-[20px] leading-[32px]"
          aria-label={mail}
        >
          {mail}
        </Link>
      </div>

      <div className="flex flex-col">
        <span className="mb-3 text-[16px] leading-[24px]">
          {translations.writeToUsBlock}
        </span>
        <div className="flex gap-2 text-white/20 opacity-65">
          <Link href={SOCIAL_CONFIG.ru.max} target="_blank" aria-label="max">
            <IconMax />
          </Link>
          <Link href={`mailto:${mail}`} aria-label="email">
            <EnvelopeFill />
          </Link>
        </div>
      </div>
    </section>
  );
};
